<app-floating-configurator />
<div class="flex items-center justify-center min-h-screen overflow-hidden">
    <div class="flex flex-col items-center justify-center">
        <div
            style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, color-mix(in srgb, orange, transparent 60%) 10%, var(--surface-ground) 30%)">
            <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20 flex flex-col items-center"
                style="border-radius: 53px">
                <span class="text-orange-500 font-bold text-5xl">404</span>
                <h1 class="text-surface-900 dark:text-surface-0 font-bold text-3xl lg:text-5xl mb-2">Erro</h1>
                <!-- <div class="text-surface-600 dark:text-surface-200 mb-8">O recurso solicitado não está disponível.</div> -->
                <a class="w-full flex items-center py-8 border-surface-300 dark:border-surface-500 border-b">
                    <span
                        class="flex justify-center items-center border-2 border-orange-500 text-orange-500 rounded-border"
                        style="height: 3.5rem; width: 3.5rem">
                        <i class="pi pi-search text-2xl!"></i>
                    </span>
                    <span class="ml-6 flex flex-col">
                        <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0 block">Página não encontrada</span>
                        <span class="text-surface-600 dark:text-surface-200 lg:text-xl">A rota informada não existe.</span>
                    </span>
                </a>
                <a class="w-full flex items-center py-8 border-surface-300">
                    <span
                        class="flex justify-center items-center border-2 border-orange-500 text-orange-500 rounded-border"
                        style="height: 3.5rem; width: 3.5rem">
                        <i class="pi pi-fw pi-exclamation-triangle text-2xl!"></i>
                    </span>
                    <span class="ml-6 flex flex-col">
                        <span class="text-surface-900 dark:text-surface-0 lg:text-xl font-medium mb-0">Recurso não encontrado</span>
                        <span class="text-surface-600 dark:text-surface-200 lg:text-xl">O recurso solicitado não está disponível.</span>
                    </span>
                </a>                
                <p-button size="large" severity="warn" label="Voltar" (click)="returnPageBack()" />
            </div>
        </div>
    </div>
</div>